module.exports = __webpack_public_path__ + "static/media/01.fed68c7e.png";